import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	TextField,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

export default function FormOnEditListPriority(props) {
	const { open, handleClose, editData, fetchAPI } = props;
	const { register, handleSubmit, errors } = useForm();
	const [onError, setOnError] = useState(true);
	const [editDatas, setEditDatas] = useState({
		id: "",
		reducetime: "",
	});

	const { id, reducetime } = editDatas;

	const onSubmit = async () => {
		const data = {
			id: id,
			sla: reducetime,
		};
		await fetchAPI("edit", data);
	};

	useEffect(() => {
		if (editData?.reducetime === editDatas?.reducetime) {
			return setOnError(true);
		}
		return setOnError(false);
	}, [editData, editDatas, onError]);

	useEffect(() => {
		if (editData) {
			setEditDatas({
				id: editData.id,
				reducetime: editData.reducetime,
			});
		}
	}, [editData]);

	const handleFieldChange = (e) =>
		setEditDatas({ ...editDatas, [e.target.name]: e.target.value });

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<form onSubmit={handleSubmit(onSubmit)}>
					<DialogTitle id="form-dialog-title">Edit On Reduce Time</DialogTitle>
					<DialogContent>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={12} md={12}>
								<TextField
									id="reducetime"
									name="reducetime"
									label="Reduce Time for %"
									error={errors.reducetime}
									style={{ minWidth: "300px" }}
									fullWidth
									placeholder="Type your Reduce Time for % "
									type="number"
									value={reducetime}
									variant="outlined"
									onChange={handleFieldChange}
									inputRef={register({
										required: {
											value: true,
											message: "Reducetime tidak boleh kosong",
										},
										maxLength: {
											value: 90,
											message: "Maximal 90%",
										},
									})}
									InputLabelProps={{ shrink: true }}
									helperText={errors.reducetime && errors.reducetime.message}
								/>
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions>
						<Button type="submit" color="primary" disabled={onError}>
							Save
						</Button>
						<Button onClick={handleClose} color="secondary">
							Cancel
						</Button>
					</DialogActions>
				</form>
			</Dialog>
		</div>
	);
}
